import { useCallback } from 'react';
import { useAnalyticsConfiguration } from 'shared/hooks/analytics/useAnalyticsConfiguration';
import {
  ActionType,
  useAnalyticsScreenKey,
} from 'shared/hooks/analytics/useAnalyticsScreenKey';
import { useValueEquivalentKeyValuesObject } from 'shared/hooks/useValueEquivalentKeyValuesObject/useValueEquivalentKeyValuesObject';
import { Maybe } from 'shared/utils/types';

export interface PressableAnalyticsProps {
  analyticsId?: string;
  customAttributes?: Maybe<Record<string, unknown>>;
}

export const usePressableAnalytics = ({
  analyticsId,
  customAttributes = null,
}: PressableAnalyticsProps) => {
  const { analyticsEvents } = useAnalyticsConfiguration();
  const screenKey = useAnalyticsScreenKey(ActionType.PRESSABLE);

  const customAttributesValue =
    useValueEquivalentKeyValuesObject(customAttributes);

  return useCallback(() => {
    if (analyticsId) {
      const key = screenKey + '/' + analyticsId;
      void analyticsEvents.logPressableEventFromConfig(
        key,
        customAttributesValue,
      );
    }
  }, [screenKey, analyticsId, analyticsEvents, customAttributesValue]);
};
